var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 3.125C17.0951 3.12503 17.375 3.40484 17.375 3.75V13.125C17.375 13.4702 17.0951 13.75 16.75 13.75C16.4048 13.75 16.125 13.4702 16.125 13.125V5.25879L4.69185 16.6919C4.44778 16.936 4.05214 16.9359 3.80806 16.6919C3.56398 16.4478 3.56398 16.0522 3.80806 15.8081L15.2412 4.375H7.37495C7.02977 4.375 6.74995 4.09518 6.74995 3.75C6.74995 3.40482 7.02977 3.125 7.37495 3.125H16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRight);
export default __webpack_public_path__ + "static/media/arrow-top-right.1eaffe3789b103a707746a574852dff9.svg";
export { ForwardRef as ReactComponent };